import React, { useEffect, useState } from "react";
import Drawer from '@mui/material/Drawer';
import { Box, Container, Divider, Grid, IconButton, Toolbar, Typography, styled } from "@mui/material";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const StyledDrawer = styled(Drawer)(({ theme, minwidth }) => ({
    '& .MuiDrawer-paper': {
        minWidth: "90%",
        boxSizing: 'border-box',
        borderRadius: "3% 0% 0% 3%",
        [theme.breakpoints.up('md')]: {
            minWidth: "50%",
        },
        [theme.breakpoints.up('lg')]: {
            minWidth: minwidth,
        },
    },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    minHeight: "50px",
    display: "flex",
    padding: "16px"
}));

const GoDrawer = ({ title, open, minwidth = "25%", onClose, children }) => {
    return (
        <div>
            <React.Fragment key="right">
                <StyledDrawer
                    minwidth={minwidth}
                    anchor="right"
                    open={open}
                >
                    <StyledToolbar>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            {title}
                        </Typography>
                        <IconButton color="info" onClick={onClose}>
                            <CloseRoundedIcon />
                        </IconButton>
                    </StyledToolbar>
                    <Divider />
                    <Container maxWidth={false}>
                        <Grid item xs={12} md={12} lg={12}>
                            {children}
                        </Grid>
                    </Container>
                </StyledDrawer>
            </React.Fragment>
        </div>
    );
}

export default GoDrawer;